export default "__VITE_ASSET__C408WsSG__"